import { useEffect } from "react";
import { createContext, useContext, useState } from "react";
import { getApiErrorMessage } from "../../../utils/apiErrorMessage";

const SnackbarContext = createContext();

export const useSnackbar = () => useContext(SnackbarContext);

export const SnackbarProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [snackbarType, setSnackbarType] = useState("error");
  const [message, setMessage] = useState(
    "Si è verificato un errore imprevisto"
  );
  const [errorResponse, setErrorResponse] = useState(null);

  useEffect(() => {
    if (!errorResponse) return;

    setMessage(getApiErrorMessage(errorResponse));
  }, [errorResponse]);

  const showSnackbarMessage = (snackbarType, customMessage) => {
    setSnackbarType(snackbarType);
    setMessage(customMessage);
    setErrorResponse(null);
    setIsOpen(true);
  };

  const showSnackbarError = (errorResponseObj) => {
    setSnackbarType("error");
    setErrorResponse(errorResponseObj);
    setIsOpen(true);
  };

  return (
    <SnackbarContext.Provider
      value={{
        isOpen,
        setIsOpen,
        snackbarType,
        message,
        showSnackbarMessage,
        showSnackbarError,
      }}
    >
      {children}
    </SnackbarContext.Provider>
  );
};
